<template>
  <v-flex mb-0 xs12 mx-2>
    <v-layout row justify-start mx-3 mt-3 align-center>
      <div class="text-xs-left" style="font-sze: 20px; font-weight: 600;">Long Distance Service Info</div>
    </v-layout>

    <v-form v-model="valid" @submit="createConferenceService" ref="createConferenceServiceForm">
      <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
        <v-layout hide-details justify-start row mt-0 mb-4>
          <!-- Left Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.ConferenceId"
              label="Conference ID*"
              required
              :rules="numberRules"
              maxlength="30"
            ></v-text-field>
            <v-text-field
              style="max-height: 45px"
              v-model="service.HostId"
              label="Host ID*"
              required
              :rules="numberRules"
              maxlength="30"
            ></v-text-field>
            <v-text-field
              style="max-height: 45px"
              v-model="service.GuestId"
              label="Guest ID*"
              required
              :rules="numberRules"
              maxlength="30"
            ></v-text-field>
          </v-flex>
          <!-- Center Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.BillPrintText"
              value="BillPrintText"
              label="Bill Print Text"
              maxlength="25"
            ></v-text-field>
          </v-flex>
          <!-- Right Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.LOA"
              label="LOA #*"
              required
              maxlength="20"
              :rules="requiredRules"
            ></v-text-field>
            <v-menu
              v-model="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                style="max-height: 44px"
                slot="activator"
                v-model="service.LOADate"
                label="LOA Date*"
                prepend-inner-icon="fa-calendar-alt"
                readonly
                clearable
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-date-picker v-model="service.LOADate" @input="menu = false"></v-date-picker>
            </v-menu>
            <v-autocomplete
              hide-details
              :items="ddlSalesIds"
              v-model="service.SalesId"
              value="SalesId"
              label="Sales ID*"
              required
              :rules="requiredRules"
              item-text="Text"
              item-value="Value"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout hide-details justify-end row mt-0 mb-4>
        <v-btn color="success" @click="createConferenceService()" class="ml-2 mr-4">Create</v-btn>
      </v-layout>
    </v-form>
  </v-flex>
</template>

<script>
import axios from "axios";
import Bus from "../../bus";

export default {
  name: "CreateConferenceService",
  props: [
    "accountNumber",
    "elementType",
    "elementDescription",
    "serviceType",
    "providerId"
  ],
  mounted() {
    // Populate Sales Ids DDL
    axios
      .get("/api/Services/GetSalesIdDDL")
      .then(response => {
        this.ddlSalesIds = response.data;
        if (this.ddlSalesIds.length === 1) {
          this.service.SalesId = this.ddlSalesIds[0].Value;
        }
      })
      .catch(error => {
        console.log(error);
      });

    // Assign props to the service object to make it easier to post to the API
    this.service.AccountNumber = this.accountNumber;
    this.service.ElementType = this.elementType;
    this.service.Description = this.elementDescription;
    this.service.Service = this.serviceType;
    this.service.Provider = this.providerId;
  },

  data() {
    return {
      service: {},
      valid: true,
      menu: false,

      // Drop down list variables
      ddlSalesIds: [],

      // Form validation Rules
      numberRules: [v => !!v || "", v => /^[0-9]*$/.test(v) || ""],
      requiredRules: [v => !!v || ""]
    };
  },

  methods: {
    createConferenceService() {
      if (this.$refs.createConferenceServiceForm.validate()) {
        axios
          .post("/api/Services/CreateConferenceService", this.service)
          .then(res => {
            console.log(res);
            Bus.$emit("alert", {
              color: "success",
              message: "Service Created Successfully!"
            });
            this.$emit("close")
          })
          .catch(err => {
            console.log(err);

            Bus.$emit("alert", {
              color: "error",
              message: "An Error Occured while Creating Service."
            });
          });
       
      }
    }
  }
};
</script>